import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      // access(30분) 만료 시 401 응답 인터셉터가 refresh로 새 토큰을 저장한 뒤 reject한다.
      // 그 직후 React Query가 새 토큰으로 자동 재요청하도록 401은 최대 2회까지 빠르게 재시도.
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } })?.response
          ?.status;
        if (status === 401) return failureCount < 2;
        return failureCount < 1;
      },
      retryDelay: (attempt) => Math.min(300 * 2 ** attempt, 2000),
    },
  },
});

// biome-ignore lint/style/noNonNullAssertion: root element guaranteed by index.html
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
